import { render, staticRenderFns } from "./TicketForTermOfSales.vue?vue&type=template&id=4c51cbd2&scoped=true&"
import script from "./TicketForTermOfSales.vue?vue&type=script&lang=js&"
export * from "./TicketForTermOfSales.vue?vue&type=script&lang=js&"
import style0 from "./TicketForTermOfSales.vue?vue&type=style&index=0&id=4c51cbd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c51cbd2",
  null
  
)

export default component.exports